<div class="header d-flex">
    <div class="pl-4">HydroTrak</div>
    <div class="d-none d-md-block ml-auto pr-4"><img src="assets/img/logo-SEW.png" height="30"></div>
</div>
<div class="wave"></div>
